import React, { useEffect, useState } from "react";
import {
  countries,
  countries_en,
} from "../../../../utils/constants/nameCountry";
import { useCurrentLanguage } from "../../../../hooks/useCurrentLanguage";
import { getSurveyJSON } from "../../../../services/jsons";
import { TOOLTIP_STYLE } from "../../../../utils/constants/graphConfigs";
import CardSurveys from "../../../reusable/CardSurveys";
import TEXT from "../../../../utils/text/carousel.json";

export default function GeneralFeelings({ isHomePageGraph, isSmall }) {
  const { language } = useCurrentLanguage();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState();
  const [flags, setFlags] = useState([]);

  //Load graph data
  useEffect(() => {
    const getData = async () => {
      const response = await getSurveyJSON("generalFeelings");

      // load images
      const flagImages = [];
      const countries = Object.keys(response.data);
      countries.forEach((e) => {
        flagImages.push(require("../../../../images/flags/" + e + ".png"));
      });

      setFlags(flagImages);
      setData(response);
      setIsLoading(false);
    };

    getData();
  }, []);

  useEffect(() => {
    if (!isLoading && data !== undefined) {
      const questionsList = data.questions[language ?? "es"];
      const countriesList = Object.keys(data.data);
      const pointsList = Object.values(data.data);

      const homeOptions = {
        title: {
          text: TEXT["feelings"]["title"][language],
          top: "top",
          left: "center",
          textStyle: {
            color: "white",
            fontSize: isSmall ? 12 : 20,
            width: isSmall ? 260 : 500,
            overflow: "break",
          },
        },
        xAxis: {
          name: questionsList[0],
          nameLocation: "middle",
          nameGap: isSmall ? 30 : 42,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: isSmall ? 9 : 14,
            width: 50,
            overflow: "break",
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            fontSize: isSmall ? 10 : 16,
          },
          axisLine: {
            lineStyle: {
              color: "white",
            },
          },
        },
        yAxis: {
          name: questionsList[1],
          nameLocation: "middle",
          nameRotate: 90,
          nameGap: isSmall ? 30 : 42,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: isSmall ? 7 : 14,
          },
          axisLine: {
            lineStyle: {
              color: "white",
            },
          },
          splitLine: {
            show: false,
          },
        },
        grid: {
          left: isSmall ? "15%" : 80,
          right: isSmall ? "7%" : 20,
          top: isSmall ? "30%" : "17%",
          bottom: isSmall ? "18%" : 60,
        },
        series: [
          {
            symbolSize: isSmall ? 25 : 40,
            data: pointsList,
            type: "scatter",
            symbol: (value, params) => {
              return "image://" + flags[params.dataIndex];
            },
          },
        ],
      };

      const surveyOptions = {
        xAxis: {
          name: questionsList[0],
          nameLocation: "middle",
          nameGap: 30,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 14,
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          name: questionsList[1],
          nameLocation: "middle",
          nameRotate: 90,
          nameGap: 34,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 14,
          },
          splitLine: {
            show: false,
          },
        },
        grid: {
          width: "77%",
          left: "17%",
          height: "80%",
          right: "7%",
          top: "5%",
        },
        series: [
          {
            symbolSize: 40,
            data: pointsList,
            type: "scatter",
            symbol: (value, params) => {
              return "image://" + flags[params.dataIndex];
            },
          },
        ],
      };

      let options = {
        tooltip: {
          show: true,
          ...TOOLTIP_STYLE,
          valueFormatter: (value) => value + "%",
          formatter: (params) => {
            let elements = [];

            elements.push("<div>");
            elements.push(
              "<span>" +
                (language === "es"
                  ? countries[countriesList[params.dataIndex]]
                  : countries_en[countriesList[params.dataIndex]]) +
                "</span>"
            );
            elements.push(
              "<div>" +
                questionsList[0] +
                ": <span>" +
                params.data[0].toFixed(1) +
                "%</span></div>"
            );
            elements.push(
              "<div>" +
                questionsList[1] +
                ": <span>" +
                params.data[1].toFixed(1) +
                "%</span></div>"
            );
            elements.push("</div>");

            return elements.join(" ");
          },
        },
      };

      options = isHomePageGraph
        ? {
            ...homeOptions,
            ...options,
          }
        : {
            ...surveyOptions,
            ...options,
          };

      console.log(options);

      setOptions(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, language]);

  return <CardSurveys isLoading={isLoading} options={options} />;
}
